package ui.app.assign.detail.kindergarten.editor.page

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyItemScope
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Chat_question
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.layer_bottom__kindergarten_device_tooltip
import ssoft.frontend.generated.resources.layer_bottom_detail_editor__page_devices
import ui.app.assign.detail.AppWrapperDevices
import ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorScope
import ui.app.assign.detail.kindergarten.editor.NextAndSkip
import ui.widget.DialogState
import ui.widget.IconicSwitch
import ui.widget.TooltipDialog

@Composable
fun AppKindergartenEditorScope.KindergartenPage01Devices(nnvl: AppKindergartenEditorScope.Wrapper) {
    val tooltipState = DialogState.remember(key = "tooltip:layer_bottom__kindergarten_device_tooltip")
    Box(Modifier.fillMaxSize()) {
        LazyColumn(
            Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(8.dp),
            contentPadding = PaddingValues(
                start = 16.dp,
                end = 16.dp,
                top = 16.dp,
                bottom = 32.dp
            )
        ) {
            stickyHeader {
                Box(
                    Modifier.fillMaxWidth()
                        .background(MaterialTheme.colorScheme.background)
                ) {
                    IconButton(
                        onClick = { tooltipState.show() },
                        modifier = Modifier.align(Alignment.Center)
                            .padding(4.dp)
                    ) {
                        Icon(
                            imageVector = Svg.Chat_question,
                            contentDescription = null,
                            modifier = Modifier.size(32.dp)
                        )
                    }
                }
            }
            items(nnvl.adapterDevices.state) { item ->
                DeviceItem(item)
            }
        }

        NextAndSkip(Modifier.align(Alignment.BottomCenter).padding(16.dp))


        TooltipDialog(
            state = tooltipState,
            title = Res.string.layer_bottom_detail_editor__page_devices,
            message = Res.string.layer_bottom__kindergarten_device_tooltip
        )


    }
}

@Composable
private fun LazyItemScope.DeviceItem(item: AppWrapperDevices.Item) {
    Card(
        onClick = { item.isActive.set(!item.isActive.state) },
        modifier = Modifier.width(384.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .padding(8.dp),
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            IconicSwitch(
                checked = item.isActive.state,
                modifier = Modifier.align(Alignment.CenterVertically),
                onCheckedChange = { item.isActive.set(it) })
            Text(
                text = item.data.name,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
        }
    }
}